import { render } from "./SchoolStudentList.vue?vue&type=template&id=657be501&scoped=true&ts=true"
import script from "./SchoolStudentList.vue?vue&type=script&lang=ts"
export * from "./SchoolStudentList.vue?vue&type=script&lang=ts"

import "./SchoolStudentList.vue?vue&type=style&index=0&id=657be501&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657be501"]])

export default __exports__